import getLang from '../../../utils/getLang';
import { useLearningContentCardModels } from '../../cards/hooks/useLearningContentCardModels';
import { useMlRecommendations } from './useMlRecommendations';
export const useMlRecommendationsContent = maxCards => {
  const {
    MlRecommendations: recommendations,
    MlRecommendationsLoading,
    MlRecommendationsError,
    correlationId,
    recommendationStrategy,
    apolloError: mlRecommendationsApolloError
  } = useMlRecommendations({
    skip: !maxCards,
    size: maxCards
  });

  // retrieves hydrated card models for the elements to render
  const {
    cardModels,
    cardModelsError,
    cardModelsLoading,
    apolloError: cardModelsApolloError
  } = useLearningContentCardModels({
    items: (recommendations === null || recommendations === void 0 ? void 0 : recommendations.map(({
      entityId,
      entityType
    }) => {
      return {
        id: entityId,
        type: entityType,
        language: getLang()
      };
    })) || [],
    skip: !(recommendations !== null && recommendations !== void 0 && recommendations.length)
  });
  return {
    content: cardModels,
    loading: MlRecommendationsLoading || cardModelsLoading || maxCards === undefined,
    error: MlRecommendationsError || cardModelsError,
    apolloError: mlRecommendationsApolloError || cardModelsApolloError,
    correlationId,
    recommendationStrategy
  };
};